// extracted by mini-css-extract-plugin
export default {"formWrapper":"product-detail-form_formWrapper__m2+sf","rowWrapper":"product-detail-form_rowWrapper__ExNMA","actionBtnWrapper":"product-detail-form_actionBtnWrapper__wSTv0"};